import { Instance } from 'mobx-state-tree';
import CollectionMapProcessor from '~/mst/models/abstract/collection_map_processor';
import model from './model';
import actions from './actions';
import views from './views';

const ThreadsStore = model.views(views).actions(actions);

export interface IThreadsStore extends Instance<typeof ThreadsStore> {}

export default CollectionMapProcessor(ThreadsStore);
